import ApiResponse from "../models/ApiResponse";
import PagedResponse from "../models/PagedResponse";
import {
  NotificationListRequest,
  NotificationListResponse,
  NotificationListPagedResponse,
  NotificationListUserResponse,
} from "../models/test-request/LaboratoryNotificationLists";
import Api from "./Api";

class LaboratoryNotificationListsApi {
  constructor(private api: Api) {}

  public getNotificationLists(
    laboratoryId: number,
    recipients?: number[],
    applicationFields?: number[],
    businessUnits?: number[],
    marketSegments?: number[],
    pageIndex = 0,
    pageSize = 25,
  ): ApiResponse<NotificationListPagedResponse> {
    const params = new URLSearchParams([
      ["pageIndex", `${pageIndex}`],
      ["pageSize", `${pageSize}`],
    ]);

    if (recipients) {
      recipients.forEach((id) => params.append("recipients", String(id)));
    }

    if (applicationFields) {
      applicationFields.forEach((id) => params.append("applicationFields", String(id)));
    }

    if (businessUnits) {
      businessUnits.forEach((id) => params.append("businessUnits", String(id)));
    }

    if (marketSegments) {
      marketSegments.forEach((id) => params.append("marketSegments", String(id)));
    }

    return this.api.get(`/test-request/v2/laboratories/${laboratoryId}/notificationlists`, { params });
  }

  public addUsersToNotificationList(
    laboratoryId: number,
    data: NotificationListRequest,
  ): ApiResponse<NotificationListResponse> {
    return this.api.put(`/test-request/v2/laboratories/${laboratoryId}/notificationlists/add-users`, data);
  }

  public getAssignableUsersForNotificationList(
    searchTerm: string,
    laboratoryId: number,
    pageIndex = 0,
    pageSize = 25,
  ): ApiResponse<PagedResponse<NotificationListUserResponse>> {
    const params = new URLSearchParams([
      ["searchTerm", searchTerm],
      ["pageIndex", `${pageIndex}`],
      ["pageSize", `${pageSize}`],
    ]);
    return this.api.get(`/test-request/v2/laboratories/${laboratoryId}/notificationlists/assignable-users`, {
      params,
    });
  }

  public removeUsersFromNotificationList(
    laboratoryId: number,
    data: NotificationListRequest,
  ): ApiResponse<NotificationListResponse> {
    return this.api.put(`/test-request/v2/laboratories/${laboratoryId}/notificationlists/remove-users`, data);
  }
}

export default LaboratoryNotificationListsApi;
